//Filtering code
let url = window.location.href;


document.querySelector('.filters').addEventListener('click', () => {
    document.querySelector('.mobile-filters').classList.toggle('show');
    document.querySelector('.mobile-sort').classList.remove('show');
})

document.querySelector('.sort-by').addEventListener('click', () => {
    document.querySelector('.mobile-sort').classList.toggle('show');
    document.querySelector('.mobile-filters').classList.remove('show');
})


//Event listener for clicking a filter button e.g. year 5
document.querySelectorAll('.filter-select').forEach((element) => {
        element.addEventListener('click', () => {toggleFilter(element)})
})

//Event listener for apply filters button
document.querySelectorAll('.apply-filters').forEach((element) => 
    {
        element.addEventListener('click', () => 
        {
            window.location = url;
        })
    }
)

//Event listener for changing sorting
document.querySelectorAll('.results-sorting').forEach( (sortingElement) => {
    sortingElement.addEventListener('change', (event) => {
        let sorting = event.target.value;
        url = url.replace('&sort=Newest', '');
        url = url.replace('?sort=Newest', '');
        url = url.replace('&sort=Oldest', '');
        url = url.replace('?sort=Oldest', '');
        url += '&sort=' + sorting;
    
        //Check search queries begins with an ?
    
        if (url.indexOf('?') == -1)
        {
            url = url.replace('&', '?');
        }
        showFilterApplyButton()
    })
})


function showFilterApplyButton()
{
    document.querySelector('.apply-wrapper').classList.add('show');
    document.querySelector('.apply-wrapper-mobile').classList.add('show');
}


function toggleFilter(element) {
    let filter = encodeURI(element.querySelector('p').getAttribute('attr-filter'));


    element.classList.toggle('active');
    if (url.includes(filter)) {
        url = url.replace('&filter[]=' + filter, '') 
        url = url.replace('?filter[]=' + filter, '') 
    }else {
        url += '&filter[]=' + filter; 
    }
        
    
    //Check search queries begins with an ?

    if (url.indexOf('?') == -1)
    {
        url = url.replace('&', '?');
    }

    showFilterApplyButton()
}